import React from 'react';

class TsMemberImg extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
		};
	}

	render () {
		return (
			<div>
				<img src={this.props.imgSrc} 
					className="bloc-rond" />
			</div>
		);
	}
}

export default TsMemberImg;


// WEBPACK FOOTER //
// ./src/js/TsMemberImg.jsx